// extracted by mini-css-extract-plugin
module.exports = {"Export_Detail_Right_Section":"ExportDetailRightSection_Export_Detail_Right_Section__3FOT_"};